module.exports = ".modalChild{overflow:hidden}\n"